import React, {useEffect, useState} from 'react'
import SignIntro from './SignIntro'
import SignBanking from './SignBanking'
import SignContact from './SignContact'
import PreferredPartnership from './PreferredPartnership'
import { useDispatch, useSelector } from 'react-redux'
import { useCache } from '../utilities/useCache'
import { AiOutlineForm } from '@react-icons/all-files/ai/AiOutlineForm';
import { FaRegHandshake } from '@react-icons/all-files/fa/FaRegHandshake';
import { FaFileSignature } from '@react-icons/all-files/fa/FaFileSignature';
import { AiOutlineArrowRight } from '@react-icons/all-files/ai/AiOutlineArrowRight';
import { AiOutlineUser } from '@react-icons/all-files/ai/AiOutlineUser';
import { AiOutlineSetting } from '@react-icons/all-files/ai/AiOutlineSetting';
import { AiOutlineDollar } from '@react-icons/all-files/ai/AiOutlineDollar';
import { AiOutlineIdcard } from '@react-icons/all-files/ai/AiOutlineIdcard';
import { AiOutlineUsergroupAdd } from '@react-icons/all-files/ai/AiOutlineUsergroupAdd';
import Clickable from './Clickable';
import B2BAgreement from './B2BAgreement';
import { getUser } from '../store/slices/user';
import { CLOSE_POPUP, SHOW_LOGIN, SHOW_POPUP, showAlert } from '../store/slices/ui';
import { useRouter } from 'next/dist/client/router';
const SignInForm = ({id }) => {
    let [step, setStep] = useState(0)
    let{push} = useRouter()
    let dispatch = useDispatch()
    let potential = useCache(`/business/withContacts/${id}`)
    let {user} = useSelector(getUser)
    let steps = [
        ['Business Information', <AiOutlineForm key='form' />, <SignIntro key='intro' potential={potential} setStep={setStep} />],
        ['Preferred Partnership Model',<FaRegHandshake key='shake'/>, <PreferredPartnership key='pref' potential={potential} setStep={setStep} /> ],
        ['Contact Information', <AiOutlineIdcard key='form' />, <SignContact key='contact'  potential={potential} setStep={setStep}  /> ],
        ['Banking', <AiOutlineDollar key='form' />, <SignBanking key='Banking' potential={potential} setStep={setStep} /> ],


        ['Review Agreement', <FaFileSignature key='form' />, <B2BAgreement key='agreement'  potential={potential} setStep={setStep}/>],

    ]

    useEffect(() => {
        window.scroll(0,0)
    }, [step])

    useEffect(()=> {
        if(!user?._id) {
            dispatch(showAlert({type: 'notice', alert: 'Please log in or create an user to access this section'}))
           
            dispatch(SHOW_LOGIN({redirect: true, showReg: true}))


        } 
    }, [])
    useEffect(()=> {
        if(potential?.status === 'partner') {
            dispatch(showAlert({type: 'notice', alert: 'This business is already a B2B partner'}))
            push('/')
        } 
    }, [potential])

    


    return <div className="signForm">
        <div className="header">
            <h1>Miami Sound Rental Partner Program</h1>
        </div>
        <div className='steps'>
     
                {steps.map((s,i) =><div key={i} className={`stepMod ${step === i ? 'open': 'closed'}`}> 

            
                <Clickable onClick={() => setStep(i)} className='rowHead'>
                    {s?.[1]}
                    <strong>{s?.[0]}</strong>
                </Clickable>
                {step === i && s?.[2]}
                </div>)}
      
        </div>
      
    </div>
}

export default SignInForm